<template>
  <div
    class="fragment-item"
    :class="{ 'fragment-item--transition': reordering && !active }"
    :style="usedStyle"
  >
    <div
      :class="[
        'video-clip-group',
        { 'video-clip-group-active': (active && !isCheck) || checkActive }
      ]"
      @click="handleClick"
    >
      <div class="video-clip-group__handle" @mousedown="handleMouseDown" />
      <div class="video-clip-group-image">
        <fragment-player
          :fragment="videoItem"
          :current="1e3"
          class="video-clip-group-thumb"
          :thumb="true"
          :visible="true"
          :style="{
            width: 225 * screenRatio + '%',
            transformOrigin: `${800 / 27 / screenRatio - 50 / 3}% 50%`
          }"
        />
        <a-checkbox
          v-if="isCheck"
          :checked="checkActive"
          class="video-clip-group__check"
          @click.native.stop
          @change="handleClick"
        />
        <div class="video-clip-options" v-else v-show="active">
          <button
            class="video-clip-op"
            :class="{
              'video-clip-op--active':
                i === 0 && showSubVideoClipList === 'replace'
            }"
            v-for="(item, i) in iconButtonList"
            :key="item"
            @click="handleIconClick(item)"
            :title="getTitle(item)"
            type="button"
          >
            <span :class="['icon iconfont', item]"></span>
          </button>
        </div>
      </div>
      <div class="video-clip-index-duration">
        <div>{{ label }}</div>
        <time-decimal-picker
          :value="videoItem.duration"
          :disabled="!active"
          @change="handleTimeChange"
          :disabledMinutes="disabledMinutes"
          :disabledSeconds="disabledSeconds"
          :min="1e3"
          :max="3e5"
        />
      </div>
    </div>
    <div
      :class="[
        'transitions',
        {
          'transitions-active': transitionActive
        }
      ]"
      v-show="!last"
      @click="handleTransitionClick"
      title="转场特效"
    >
      <span
        :class="[
          'icon iconfont',
          {
            'icon-active': transitionActive
          }
        ]"
        >&#xe635;</span
      >
      <div :class="[{ 'name-active': videoItem.transition }]">
        {{ getTransitionName(videoItem) }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FragmentPlayer from '../player/FragmentPlayer';
import TimeDecimalPicker from '../base/TimeDecimalPicker';
import { isMac } from '../../utils';

export default {
  props: ['active', 'isCheck', 'checkActive', 'videoItem', 'last', 'transitionActive', 'label'],
  components: {
    'fragment-player': FragmentPlayer,
    'time-decimal-picker': TimeDecimalPicker
  },
  data() {
    return {
      iconButtonList: ['icon-qiehuan', 'icon-ziyuan61', 'icon-ziyuan80'],
      offset: 0
    };
  },
  methods: {
    ...mapMutations(['handleShowSubVideoClipList', 'handleShowTransitionList', 'handleActiveTransitionIndex']),
    ...mapActions(['handleFragmentsDuration']),
    handleTimeChange(e) {
      this.handleFragmentsDuration(e);
    },
    getTitle(icon) {
      return {
        'icon-ziyuan61': '复制片段',
        'icon-ziyuan80': '删除片段'
      }[icon]
    },
    disabledMinutes() {
      const ret = [];
      for (let i = 6; i < 60; i++) {
        ret.push(i);
      }
      return ret;
    },
    disabledSeconds(_, minutes) {
      const ret = [];
      if (minutes === 0) {
        // return [0, 1, 2];
        return [0];
      }
      if (minutes === 5) {
        for (let i = 1; i < 60; i++) {
          ret.push(i);
        }
      }
      return ret;
    },
    getTransitionName(videoItem) {
      let name = this.transitionNames[
        videoItem.transition
          ? videoItem.transition.name
          : "none"
      ];

      return videoItem.transition ? name + '（' + videoItem.transition.duration / 1000 + '秒）' : name
    },
    handleClick(e) {
      if (this.isCheck || isMac && e.metaKey || e.ctrlKey) {
        this.$emit('checkItem', e);
        return;
      }
      this.$emit('selectItem', e);
    },
    handleIconClick: function (icon) {
      this.$emit('iconClick', icon);
    },
    handleTransitionClick(e) {
      this.$emit('transitionClick', e);
    },
    handleMouseDown(e) {
      if (this.isCheck || isMac && e.metaKey || e.ctrlKey) {
        return;
      }
      if (!e.button) {
        this.$emit('selectItem', e);
        document.body.classList.add('unselectable');
        this.reordering = {
          x: e.clientX,
          y: e.clientY
        };
      }
    },
    handleMouseMove(e) {
      if (this.reordering) {
        if (this.active) {
          this.offset = e.clientY - this.reordering.y;
        } else {
          const bcr = this.$el.getBoundingClientRect();
          if (e.clientY > bcr.top && e.clientY < bcr.bottom) {
            this.$emit(
              e.clientY < (bcr.top + bcr.bottom) / 2
                ? 'before'
                : 'after',
              e
            );
          }
        }
      }
    },
    handleMouseUp() {
      if (this.reordering && this.active) {
        this.offset = 0;
        // TODO: process reordering
        this.$store.dispatch('reorderFragment');
        setTimeout(() => {
          document.body.classList.remove('unselectable');
        }, 0);
      }
    }
  },
  computed: {
    ...mapState(['activeTransitionIndex', 'showTransitionList', 'effects', 'screenRatio', 'showSubVideoClipList', 'transitionNames']),
    ...mapGetters(['activeFragment']),
    reordering: {
      get() {
        return this.$store.state.fragmentReordering;
      },
      set(value) {
        this.$store.commit('handleFragmentReorder', value);
      }
    },
    usedStyle() {
      if (this.active && this.reordering) {
        return {
          transform: `translateY(${this.offset}px)`,
          zIndex: 1
        };
      }
      return {};
    }
  },
  mounted() {
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mouseup', this.handleMouseUp);
  }
}
</script>

<style scoped>
.fragment-item {
  position: relative;
  z-index: 0;
}

.fragment-item--transition {
  transition: 0.2s;
}

.video-clip-group,
.video-clip-op {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-clip-group {
  width: 224px;
  height: 169px;
  background: rgba(236, 240, 241, 1);
  border: 1px solid transparent;
  position: relative;
  z-index: 0;
  transition: 0.1s;
}

.video-clip-group-active {
  border: 1px solid #007eff;
}

.video-clip-group:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1), 0 0 8px rgba(0, 0, 0, 0.06);
}

.video-clip-group-image {
  width: 202px;
  height: 114px;
  margin-top: 12px;
  overflow: hidden;
  position: relative;
}

.video-clip-group-thumb {
  transform: scale(0.25);
  width: 400%;
  height: 400%;
  top: 0;
  margin: auto 0;
  transform-origin: left;
  z-index: 0;
}

.icon {
  font-size: 12px;
  color: #ffffff;
  transform: scale(0.92);
}

.video-clip-group__check {
  position: absolute;
  left: 6px;
  top: 4px;
  z-index: 2;
}

.video-clip-options {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  display: flex;
}

.video-clip-op {
  width: 22px;
  height: 22px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  justify-content: center;
  margin: 4px 4px 0 0;
  outline: none;
  border: 0;
}

.video-clip-op:hover,
.video-clip-op:focus {
  background-color: rgba(0, 0, 0, 0.8);
}

.video-clip-op--active {
  background-color: rgba(0, 126, 255, 0.6);
}

.video-clip-op--active:hover,
.video-clip-op--active:focus {
  background-color: #007eff;
}

.video-clip-index-duration {
  width: 100%;
  padding: 6px 11px 0 11px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  /* color: rgba(0, 0, 0, 0.65); */
}

.video-clip-group__handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: move;
  z-index: 1;
}

.transitions {
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(108, 109, 110, 1);
  cursor: pointer;
}

.transitions .icon {
  margin-right: 12px;
  color: #6c6d6e;
}

.transitions-active {
  color: #007eff;
}

.transitions .icon-active {
  color: #007eff;
}

.name-active {
  font-weight: bold;
  color: #010101;
}
</style>